module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/monza.c9c14630eb3857ac72addad118d94c9d.jpg";